export const navItems = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-home',
  }, {
    name: 'Manage Sub Admin',
    url: '/subadmin/list',
    icon: 'icon-user'
  }, {
    name: 'Manage Users',
    url: '/manage-user/list',
    icon: 'icon-user'
  }, {
    name: 'CMS Management',
    url: '/cms/list',
    icon: 'fa fa-file-o'
  }, {
    name: 'Manage Category',
    url: '/category/list',
    icon: 'fa fa-list'
  }, {
    name: 'Email Template',
    url: '/email/list',
    icon: 'icon-envelope'
  }, {
    name: 'FAQ Management',
    url: '/faq/list',
    icon: 'icon-question'
  }, {
    name: 'System Permissions',
    url: '/role-permissions',
    icon: 'icon-lock'
  }, {
    name: 'Settings',
    url: '/settings',
    icon: 'icon-settings'
  },
];
